import { EMPTY, of } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { utilAnimation } from "../../../utils/animation/utilAnimation";
import { actionPlayerSettingsSetAutoAnimation } from "../../info/player-settings/actionPlayerSettingsInfo";
import { TypeActionLoading } from "../../loading/actionLoading";
import { IdAssetBundleCore } from "../../loading/IdAssetBundleCore";
export var epicCacheAnimations = function (action$) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionLoading.Complete &&
            action.bundleId === IdAssetBundleCore.Animations;
    }), switchMap(function (action) {
        utilAnimation.registerAnimations(action.loader.resources);
        var autoAnimation = utilAnimation.getAnimationSetting().autoAnimation;
        if (autoAnimation) {
            return of(actionPlayerSettingsSetAutoAnimation());
        }
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/animation/epics/epicCacheAnimations.ts
// module id = 1765
// module chunks = 3